import { render, staticRenderFns } from "./DiscountedProducts.vue?vue&type=template&id=0f723e3f&scoped=true&"
import script from "./DiscountedProducts.vue?vue&type=script&lang=js&"
export * from "./DiscountedProducts.vue?vue&type=script&lang=js&"
import style0 from "./DiscountedProducts.vue?vue&type=style&index=0&id=0f723e3f&lang=scss&scoped=true&"
import style1 from "./DiscountedProducts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f723e3f",
  null
  
)

export default component.exports